import api from "../../services/instanceapi";
import {
    DELETE_INDICATOR,
    DELETE_INDICATOR_FAIL, FETCH_INDICATOR, LOAD_INDICATOR, LOAD_INDICATOR_FAIL,
    PATCH_INDICATOR, PATCH_INDICATOR_FAIL,
    POST_INDICATOR,
    POST_INDICATOR_FAIL
} from "./actionTypes";
import {allKeyResults, oneKeyResultURL} from "../../services/api";
import {checkErrorMessage} from "../../utils/utils";


export const loadIndicator = (id) => async (dispatch) => {

    dispatch({type:LOAD_INDICATOR})
    try {
        const res = await api.get(oneKeyResultURL(id));

        dispatch({
            type: FETCH_INDICATOR,
            payload: {
                id: res.data.id,
                comment:res.data.comment,
                title: res.data.title,
                target: res.data.target,
                advancement: res.data.advancement,
                advancementType: res.data.advancementType,
                pilot: res.data.pilot,
                endDate:res.data.endDate,
                lastUpdate: res.data.lastUpdate,
                onGoing : res.data.onGoing,
                OKRId : res.data.OKRId,
                OKRPilot:res.data.OKRPilot,
                OKRTitle:res.data.OKRTitle,
                status: res.status,
                message: res.statusText,
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: LOAD_INDICATOR_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
        return Promise.reject(e)

    }
}

export const postIndicator = (data) => async (dispatch) => {
    try {
        const res = await api.post(allKeyResults(), data);
        dispatch({
            type: POST_INDICATOR,
            payload: {
                status: res.status,
                message: res.statusText
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: POST_INDICATOR_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
        return Promise.reject(e)

    }
}
export const patchIndicator = (id, data) => async (dispatch) => {
    try {
        const res = await api.patch(oneKeyResultURL(id), data);
        dispatch({
            type: PATCH_INDICATOR,
            payload: {
                status: res.status,
                message: res.statusText
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: PATCH_INDICATOR_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
        return Promise.reject(e)
    }
}

export const deleteIndicator = (id) => async (dispatch) => {
    try {
        const res = await api.delete(oneKeyResultURL(id));
        dispatch({
            type: DELETE_INDICATOR,
            payload: {
                status: res.status
            }
        })
        return Promise.resolve()

    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: DELETE_INDICATOR_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
        return Promise.reject(e)

    }
}
